"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Registration Service
 * Provides endpoints for users to register for the EVE and SAVE on-boarding processes.<br><br> Users created here will have a role of REGISTRATION. Once created they login through the normal legacy-idp process at which point the applications direct them to their respective on-boarding process.
 *
 * The version of the OpenAPI document: 1.0.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewalRequestApplicationEnum = exports.RenewalRequestToJSON = exports.RenewalRequestFromJSONTyped = exports.RenewalRequestFromJSON = void 0;
var runtime_1 = require("../runtime");
function RenewalRequestFromJSON(json) {
    return RenewalRequestFromJSONTyped(json, false);
}
exports.RenewalRequestFromJSON = RenewalRequestFromJSON;
function RenewalRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'application': json['application'],
        'email': !runtime_1.exists(json, 'email') ? undefined : json['email'],
        'otc': !runtime_1.exists(json, 'otc') ? undefined : json['otc'],
    };
}
exports.RenewalRequestFromJSONTyped = RenewalRequestFromJSONTyped;
function RenewalRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'application': value.application,
        'email': value.email,
        'otc': value.otc,
    };
}
exports.RenewalRequestToJSON = RenewalRequestToJSON;
/**
* @export
* @enum {string}
*/
var RenewalRequestApplicationEnum;
(function (RenewalRequestApplicationEnum) {
    RenewalRequestApplicationEnum["SAVE"] = "SAVE";
    RenewalRequestApplicationEnum["EVERIFY"] = "EVERIFY";
})(RenewalRequestApplicationEnum = exports.RenewalRequestApplicationEnum || (exports.RenewalRequestApplicationEnum = {}));
